<div class="accounts-header px-3 py-2 d-flex justify-content-between">
  <span
    class="text-muted"
    i18n="accountSelector|Header text for change action@@accountsActionChange"
  >
    Change account and ship-to address(es)
  </span>
  @if (isDeselectAllShown$ | async) {
  <span
    data-e2e="deselect-all-btn"
    (click)="handleDeselectAll()"
    i18n="accountSelector|Deselect all text@@accountsDeselectAll"
    class="font-weight-bold cursor-pointer text-center"
    >Deselect All</span
  >
  }
</div>

<epc-search-accounts-input class="mx-3"></epc-search-accounts-input>

<section class="flex-grow-1 position-relative overflow-auto d-flex flex-column">
  <epc-accounts-form
    [loading]="isLoading$ | async"
    [isSingleSelection]="isSingleSelection$ | async"
    [accounts]="sortedAccounts$ | async"
    [isAccountAddressReverted]="isAccountAddressReverted$ | async"
    [searchValue]="accountSearchValue$ | async"
    [shouldHighlightAddress]="shouldHighlightAddress$ | async"
    [noSearchResult]="noSearchResult$ | async"
    [shouldScrollToTheTop]="searchCleared$ | async"
    [selectedAccountIds]="selectedAccountIds$ | async"
    [selectedAddressIds]="selectedAddressesIds$ | async"
    (setNextPage)="setPage()"
    (toggleAccountSelection)="handleAccountToggle($event)"
    (toggleAddressSelection)="handleAddressToggle($event)"
  >
  </epc-accounts-form>
</section>

@if (isSelectedAccountsShown$ | async) {
<epc-selected-accounts
  [selectedAccounts]="selectedAccounts$ | async"
  [isAccountAddressReverted]="isAccountAddressReverted$ | async"
  (toggleAccountSelection)="handleAccountToggle($event)"
></epc-selected-accounts>
}

<div class="p-3 border-top">
  <button
    type="button"
    [disabled]="isConfirmButtonDisabled$ | async"
    (click)="handleCreateNewBasket()"
    data-e2e="create-basket-btn"
    class="btn btn-primary btn-block"
  >
    <ng-container *ngrxLet="selectedShopsCount$; let count">
      {{ createBtnTitle(count) }}
    </ng-container>
  </button>
</div>
